import { JDSFileUploaderPanelProps } from './generated/interface';
import { useToggle } from '../../hooks/useToggle';

export interface FileUploaderPanelProps extends JDSFileUploaderPanelProps {
  onClose?: (index?: number) => void;
}

export const withLogic =
  (
    Component: React.ComponentType<FileUploaderPanelProps>
  ): React.FC<FileUploaderPanelProps> =>
  (props: FileUploaderPanelProps) => {
    const { toggle, selected } = useToggle(props.expanded, true);

    return (
      <Component
        {...{
          ...props,
          expanded: selected,
          onClick: (ev) => {
            if (selected) props.onClose?.();
            else props.onClick?.(ev);
            toggle();
          },
          onClose: (index?: number) => {
            props.onClose?.(index);
          }
        }}
      />
    );
  };
